export function numberToBRL(value: number): string {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}

export function BRLToNumber(value: string): number {
  return parseFloat(value.replace('R$ ', '').replace('.', '').replace(',', '.'));
}

export type FormatMoneyOptions = {
  locales?: string | string[];
} & Intl.NumberFormatOptions;

export function formatNumber(value: number, { locales = 'pt-BR', ...options }: FormatMoneyOptions = {}) {
  return Intl.NumberFormat(locales, options).format(value);
}

export function formatMoney(value: number, options: FormatMoneyOptions = { currency: 'BRL' }) {
  return formatNumber(value, { style: 'currency', ...options });
}

export function formatPercentual(value: number) {
  return `${formatNumber(value, { minimumFractionDigits: 0 })}%`;
}
